import { useMemo } from 'react';

import { Asset } from '../..';
import { fundsOffersQueryUpdated } from '../../../../../../../../store/product/selectors';
import { DynamicAssetsQueryParams } from '../../../../../../../../store/product/types';
import { FeatureToggle, useUnleashFlags } from '../../../../../../../../utils/useUnleashFlags';

import { FundsListItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const FundsAsset = () => {
  const { b2bEnableFundsOffersV2 } = useUnleashFlags(FeatureToggle.FundsOffersV2);

  const productsQuery = useMemo(
    () => (params: DynamicAssetsQueryParams) =>
      fundsOffersQueryUpdated({
        ...params,
        fundsOffersV2Enabled: !!b2bEnableFundsOffersV2,
      }),
    [b2bEnableFundsOffersV2]
  );

  return (
    <Asset
      productsQuery={productsQuery}
      ProductItem={FundsListItem}
      ProductItemLoading={ListLoadingItem}
      keySelector="productIdNormalized"
    />
  );
};
